<app-toast-message *ngFor="let message of (messages | async)"
  [message]="message"
  @toastInOut>
</app-toast-message>
